"use client";

import { c as _c } from "react/compiler-runtime";
import CommonTableSortIcon from "@/components/user/utils/icons/CommonTableSortIcon";
import type { SortDirection } from "@/entities/ISort";
import { useAnimate } from "framer-motion";
import { useEffect, useMemo, useRef, useState } from "react";
import type { CommonSelectProps } from "../CommonSelect";
import CommonDropdownItem from "./CommonDropdownItem";
import CommonDropdownItemsWrapper from "./CommonDropdownItemsWrapper";
export default function CommonDropdown(props) {
  const $ = _c(57);
  const {
    items,
    activeItem,
    noneLabel,
    filterLabel,
    setSelected,
    dynamicPosition: t0,
    disabled: t1,
    theme: t2,
    size: t3,
    renderItemChildren,
    closeOnSelect: t4,
    showFilterLabel: t5
  } = props;
  const dynamicPosition = t0 === undefined ? true : t0;
  const disabled = t1 === undefined ? false : t1;
  const theme = t2 === undefined ? "dark" : t2;
  const size = t3 === undefined ? "md" : t3;
  const closeOnSelect = t4 === undefined ? true : t4;
  const showFilterLabel = t5 === undefined ? false : t5;
  const [isOpen, setIsOpen] = useState(false);
  const [iconScope, animateIcon] = useAnimate();
  let t6;
  let t7;
  if ($[0] !== animateIcon || $[1] !== iconScope || $[2] !== isOpen) {
    t6 = () => {
      if (!iconScope.current) {
        return;
      }
      if (isOpen) {
        animateIcon(iconScope.current, {
          rotate: 0
        });
      } else {
        animateIcon(iconScope.current, {
          rotate: -90
        });
      }
    };
    t7 = [animateIcon, iconScope, isOpen];
    $[0] = animateIcon;
    $[1] = iconScope;
    $[2] = isOpen;
    $[3] = t6;
    $[4] = t7;
  } else {
    t6 = $[3];
    t7 = $[4];
  }
  useEffect(t6, t7);
  let t8;
  if ($[5] !== activeItem || $[6] !== items) {
    let t9;
    if ($[8] !== activeItem) {
      t9 = item => item.value === activeItem;
      $[8] = activeItem;
      $[9] = t9;
    } else {
      t9 = $[9];
    }
    t8 = items.find(t9);
    $[5] = activeItem;
    $[6] = items;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const activeItemMatch = t8;
  const computedLabel = activeItemMatch?.mobileLabel ?? activeItemMatch?.label ?? noneLabel ?? "None Selected";
  let t9;
  if ($[10] !== props) {
    const getSortDirection = () => "sortDirection" in props ? props.sortDirection : undefined;
    t9 = getSortDirection();
    $[10] = props;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const sortDirection = t9;
  let t10;
  if ($[12] !== closeOnSelect || $[13] !== setSelected) {
    t10 = item_0 => {
      setSelected(item_0);
      if (closeOnSelect) {
        setIsOpen(false);
      }
    };
    $[12] = closeOnSelect;
    $[13] = setSelected;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  const onSelect = t10;
  const buttonRef = useRef(null);
  const [isMobile, setIsMobile] = useState(false);
  const t11 = `${filterLabel}: ${computedLabel}`;
  let t12;
  if ($[15] !== isOpen) {
    t12 = () => setIsOpen(!isOpen);
    $[15] = isOpen;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  const t13 = `${disabled ? "tw-opacity-50 tw-text-iron-400" : "hover:tw-ring-iron-600 tw-text-iron-300"} ${theme === "dark" ? "tw-bg-iron-800 lg:tw-bg-iron-900" : "tw-bg-iron-800"} ${size === "md" ? "tw-py-3 tw-text-sm" : size === "tabs" ? "tw-py-[11px] tw-text-sm" : "tw-py-2.5 tw-text-xs"} tw-w-full tw-truncate tw-text-left tw-relative tw-block tw-whitespace-nowrap tw-rounded-lg tw-border-0 tw-pl-3.5 tw-pr-8 tw-font-semibold tw-caret-primary-400 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700
          focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset focus:tw-ring-primary-400 hover:tw-bg-iron-800 tw-transition tw-duration-300 tw-ease-out tw-justify-between`;
  let t14;
  if ($[17] !== filterLabel || $[18] !== showFilterLabel) {
    t14 = showFilterLabel && <span className="tw-font-semibold tw-text-iron-500">{filterLabel}: </span>;
    $[17] = filterLabel;
    $[18] = showFilterLabel;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== sortDirection) {
    t15 = sortDirection && <span className="-tw-mt-0.5 tw-ml-2"><CommonTableSortIcon direction={sortDirection} isActive={true} /></span>;
    $[20] = sortDirection;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  let t16;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <path d="M6 9L12 15L18 9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== iconScope) {
    t17 = <div className="tw-pointer-events-none tw-absolute tw-inset-y-0 tw-right-0 tw-flex tw-items-center -tw-mr-1 tw-pr-3.5"><svg ref={iconScope} className="tw-h-4 tw-w-4" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">{t16}</svg></div>;
    $[23] = iconScope;
    $[24] = t17;
  } else {
    t17 = $[24];
  }
  let t18;
  if ($[25] !== computedLabel || $[26] !== disabled || $[27] !== isOpen || $[28] !== t11 || $[29] !== t12 || $[30] !== t13 || $[31] !== t14 || $[32] !== t15 || $[33] !== t17) {
    t18 = <div className="tw-relative tw-w-full"><button ref={buttonRef} type="button" aria-haspopup="true" aria-label={t11} aria-expanded={isOpen} onClick={t12} disabled={disabled} className={t13}>{t14}{computedLabel}{t15}{t17}</button></div>;
    $[25] = computedLabel;
    $[26] = disabled;
    $[27] = isOpen;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
    $[32] = t15;
    $[33] = t17;
    $[34] = t18;
  } else {
    t18 = $[34];
  }
  let t19;
  if ($[35] !== activeItem || $[36] !== isMobile || $[37] !== items || $[38] !== onSelect || $[39] !== renderItemChildren || $[40] !== sortDirection) {
    let t20;
    if ($[42] !== activeItem || $[43] !== isMobile || $[44] !== items.length || $[45] !== onSelect || $[46] !== renderItemChildren || $[47] !== sortDirection) {
      t20 = (item_1, i) => <CommonDropdownItem key={item_1.key} item={item_1} itemIdx={i} totalItems={items.length} activeItem={activeItem} sortDirection={sortDirection} isMobile={isMobile} setSelected={onSelect}>{renderItemChildren?.(item_1)}</CommonDropdownItem>;
      $[42] = activeItem;
      $[43] = isMobile;
      $[44] = items.length;
      $[45] = onSelect;
      $[46] = renderItemChildren;
      $[47] = sortDirection;
      $[48] = t20;
    } else {
      t20 = $[48];
    }
    t19 = items.map(t20);
    $[35] = activeItem;
    $[36] = isMobile;
    $[37] = items;
    $[38] = onSelect;
    $[39] = renderItemChildren;
    $[40] = sortDirection;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  let t20;
  if ($[49] !== dynamicPosition || $[50] !== filterLabel || $[51] !== isOpen || $[52] !== t19) {
    t20 = <CommonDropdownItemsWrapper isOpen={isOpen} setOpen={setIsOpen} buttonRef={buttonRef} filterLabel={filterLabel} dynamicPosition={dynamicPosition} onIsMobile={setIsMobile}>{t19}</CommonDropdownItemsWrapper>;
    $[49] = dynamicPosition;
    $[50] = filterLabel;
    $[51] = isOpen;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== t18 || $[55] !== t20) {
    t21 = <div className="tailwind-scope tw-w-full tw-h-full">{t18}{t20}</div>;
    $[54] = t18;
    $[55] = t20;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  return t21;
}